import script from "./ProjectsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsView.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsView.vue?vue&type=style&index=0&id=81d142a2&lang=scss&scoped=true"

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81d142a2"]])

export default __exports__